export default "__VITE_ASSET__3L0WrcVE__"